// AUTO GENERATED FILE - Changes WILL be lost.
// id - used as 'id' fallback
export const common_fallback = true

export const translations = {}
